import React, { useState } from 'react';
import { loginAction } from '../utils/action';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { setAuthUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await loginAction({ email, password });
      console.log(data);
      setAuthUser(data);
      // Redirect ke dashboard (atau ganti sesuai kebutuhan)
      navigate('/');
    } catch (err) {
      console.error(err);
      setError(err.message || 'Email atau password salah.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center bg-light vh-100">
      <div
        className="card shadow-sm border-0 rounded-4 p-4"
        style={{ width: '100%', maxWidth: '420px' }}
      >
        <div className="text-center mb-4">
          <i className="bi bi-person-circle fs-1 text-primary mb-2"></i>
          <h5 className="fw-bold">Masuk ke ILS-SA</h5>
          <p className="text-muted small mb-0">
            Integrated Leadership System — Bakrie Center Foundation
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label fw-semibold">
              Email
            </label>
            <div className="input-group">
              <span className="input-group-text bg-white">
                <i className="bi bi-envelope"></i>
              </span>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="example@bcf.or.id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label fw-semibold">
              Password
            </label>
            <div className="input-group">
              <span className="input-group-text bg-white">
                <i className="bi bi-lock"></i>
              </span>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          {error && (
            <div className="alert alert-danger py-2 small">{error}</div>
          )}

          <button
            type="submit"
            className="btn btn-primary w-100 rounded-3"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Sedang masuk...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-2"></i> Masuk
              </>
            )}
          </button>
        </form>

        <p className="text-center text-muted small mt-3 mb-0">
          © {new Date().getFullYear()} Bakrie Center Foundation
        </p>
      </div>
    </div>
  );
}
